import { GET } from './index'

const pad = n => (n < 10 ? `0${n}` : `${n}`)

const toBackendDate = date => {
  const d = date instanceof Date ? date : new Date(date)
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`
}

export const getClassSessionsByDay = ({ date }) =>
  GET({ url: `/api/instructor/class-sessions/by-day?date=${toBackendDate(date)}` })
